import React, { useCallback } from 'react';

import ButtonUI from '../../../UI/Button/ButtonUI';
import MaskField from '../../../UI/Field/Mask/MaskField';
import AlphanumericMaskField from '../../../UI/Field/Mask/AlphanumericMaskField';
import WrapperSubTitleForm from '../../../UI/WrapperSubTitleForm/WrapperSubTitleForm';
import Grid24 from '../../../UI/Grid24/Grid24';
import InputField from '../../../UI/Field/Input/InputField';

import { CPF_MASK } from '../../../../helpers/constants/layout.constants';
import { useCrudBorderoSelector, useCrudBoderoDispatch } from '../../../../store/Borderos/Crud/CrudBorderoProvider';
import { setAttributeAction } from '../../../../store/Borderos/Crud/CrudBordero.store';
import { findClienteByIdAction } from '../../../../store/Borderos/Crud/CrudBorderos.saga';

import useCrudBorderoStyles from '../CrudBordero.styles';
import NumberInput from '../../../UI/Field/Number/NumberInput';

const constants = {
  TITLE_REGISTER_MODE: 'Informe o Código do cliente para o qual deseja cadastrar o Borderô',
  TITLE_INSPECT_MODE: 'Dados do Cliente',
  CONSULTAR: 'Consultar',
  CODIGO: 'Código',
  CODIGO_CLIENTE: 'Código do Cliente*',
  NOME: 'Razão Social/Nome',
  DOCUMENTO: 'CPF/CNPJ',
  CIDADE: 'Cidade',
  ESTADO: 'Estado',
};

export default function DadosClienteCrudBordero({ wrapperByMode }) {
  const styleCrudBordero = useCrudBorderoStyles();
  const dispatch = useCrudBoderoDispatch();

  const codigoCliente = useCrudBorderoSelector(states => states.requestFields.codigoCliente);
  const idCliente = useCrudBorderoSelector(states => states.requestFields.cliente.idCliente);
  const nome = useCrudBorderoSelector(states => states.requestFields.cliente.nome);
  const idEstado = useCrudBorderoSelector(states => states.requestFields.cliente.idEstado);
  const cidade = useCrudBorderoSelector(states => states.requestFields.cliente.cidade);
  const documento = useCrudBorderoSelector(states => states.requestFields.cliente.documento);

  const loadingCliente = useCrudBorderoSelector(states => states.loading.cliente);

  const isCnpj = documento.value.length > 11;

  const changeFieldsHandler = useCallback((event) => {
    const { name, value } = event.target;
    dispatch(setAttributeAction(name, value));
  }, [dispatch]);

  const findClienteHandler = () => {
    dispatch(findClienteByIdAction(codigoCliente.value));
  };

  const buildSearchCliente = () => (
    <Grid24 container isFormContainer spacing="1" style={{ marginBottom: '16px' }}>
      <Grid24 item xs={24} sm={3}>
        <NumberInput
          isForm
          numberType="integer"
          maxValue={999999999}
          name={codigoCliente.name}
          label={constants.CODIGO_CLIENTE}
          value={codigoCliente.value}
          error={codigoCliente.error}
          errorMessage={codigoCliente.errorMessage}
          acceptEmptyValue
          fullWidth
          onChange={changeFieldsHandler}
        />
      </Grid24>
      <Grid24 item xs={24} sm={3}>
        <ButtonUI
          disabled={codigoCliente.value.trim().length === 0}
          className={styleCrudBordero.searchButton}
          showLoading={loadingCliente}
          onClick={findClienteHandler}
        >
          {constants.CONSULTAR}
        </ButtonUI>
      </Grid24>
    </Grid24>
  );

  return (
    <WrapperSubTitleForm title={wrapperByMode(constants.TITLE_REGISTER_MODE, constants.TITLE_INSPECT_MODE)}>
      {wrapperByMode(buildSearchCliente(), null)}
      <Grid24 container isFormContainer spacing="1">
        <Grid24 xs={24} sm={2}>
          <InputField
            disabled
            isForm
            fullWidth
            label={constants.CODIGO}
            acceptEmptyValue
            value={idCliente.value ? Number(String(idCliente.value)).toLocaleString('pt-BR', { minimumFractionDigits: 0 }) : null}
          />
        </Grid24>
        <Grid24 xs={24} sm={10}>
          <InputField
            disabled
            isForm
            fullWidth
            label={constants.NOME}
            value={nome.value}
          />
        </Grid24>
        <Grid24 xs={24} sm={4}>
          {isCnpj ? (
            <AlphanumericMaskField
              disabled
              isForm
              fullWidth
              label={constants.DOCUMENTO}
              value={documento.value}
            />
          ) : (
            <MaskField
              disabled
              isForm
              fullWidth
              label={constants.DOCUMENTO}
              value={documento.value}
              format={CPF_MASK}
            />
          )}
        </Grid24>
        <Grid24 xs={24} sm={6}>
          <InputField
            disabled
            isForm
            fullWidth
            label={constants.CIDADE}
            value={cidade.value}
          />
        </Grid24>
        <Grid24 xs={24} sm={2}>
          <InputField
            disabled
            isForm
            fullWidth
            label={constants.ESTADO}
            value={idEstado.value}
          />
        </Grid24>
      </Grid24>
    </WrapperSubTitleForm>
  );
}
